import React from "react";
var defaultBreakpoints = {
    s: 336,
    m: 560,
    l: 1080,
    xl: 1464,
    xxl: undefined
};
var updatedDefaultBreakpoints = {
    s: 560,
    m: 800,
    l: 1080,
    xl: 1280,
    xxl: 1464
};
var BreakpointsContext = React.createContext(defaultBreakpoints);
var BreakpointsProvider = BreakpointsContext.Provider, BreakpointsConsumer = BreakpointsContext.Consumer;
var useBreakpoints = function() {
    return React.useContext(BreakpointsContext);
};
export { BreakpointsProvider, BreakpointsConsumer, BreakpointsContext, defaultBreakpoints, updatedDefaultBreakpoints, useBreakpoints };
